import React from "react";

const OnDeviceIndicator = () => (
  <div className="absolute z-50 top-[-0.90rem] left-1 rounded-full bg-primary px-1.5 py-0.5 text-xs text-on-primary">
    On Device
  </div>
);

export default OnDeviceIndicator;
